<div class="container-scroller">
  <div class="container-fluid page-body-wrapper full-page-wrapper">
    <div class="content-wrapper d-flex align-items-center auth px-0">
      <div class="row w-100 mx-0">
        <div class="col-lg-5 mx-auto">
          @if (notVerifiedMessage) {
            <div
              class="min_media alert alert-danger d-flex align-items-start alert-dismissible fade show mb-6 notVerifiedMessage">
              <mat-icon class="me-2 bi flex-shrink-0">cancel</mat-icon>
              <div>Account not verified. Please check your inbox to verify your account and log in.</div>
            </div>
          }
          @if (verifiedMessage) {
            <div
              class="min_media alert alert-success d-flex align-items-center alert-dismissible fade show mb-6 successMessage">
              <img src="assets/svg/successIcon.svg" alt="Success Icon" class="me-2">
              <div>You have successfully verified your account.</div>
            </div>
          }
          <div class="auth-form-light pt-custom text-left py-5 px-4 px-sm-5 position-relative">
            <app-search></app-search>
            <h2 class="login-title"> Welcome Back</h2>
            <form [formGroup]="form" (ngSubmit)="login()"
                  (keydown.enter)="$event.preventDefault(); loginButton.focus(); loginButton.click()" method="post"
                  class="pt-3">
              <div class="form-group">
                <input id="email" type="text" name="email" formControlName="email" placeholder="Email"
                       class="form-control form-control-lg"
                       [ngClass]="{'has-error': loginFormControl['email'].invalid && loginFormControl['email'].touched}"
                       (click)="resetErrorMessage()"
                       autocomplete="off"/>
                @if (loginFormControl['email'].invalid && loginFormControl['email'].touched) {
                  <div class="validation">
                    @if (loginFormControl['email'].errors?.['required']) {
                      <small>Enter email</small>
                    }
                    @if (loginFormControl['email'].errors?.['pattern']) {
                      <small>Enter valid email</small>
                    }
                  </div>
                }
              </div>
              <div class="form-group">
                <div class="mr-2 flex-fill me-4 password-max-width">
                  <div class="password-input-container">
                    <input formControlName="password" [type]="showPassword ? 'text' : 'password'" #passwordInput
                           placeholder="Password"
                           class="form-control form-control-lg"
                           [ngClass]="{'has-error': loginFormControl['password'].invalid && loginFormControl['password'].touched}"
                           (click)="resetErrorMessage()"
                           autocomplete="off"/>
                    <span class="eye-icon">
                           <i class="bi" [ngClass]="{'bi-eye': showPassword, 'bi-eye-slash': !showPassword}"
                              (click)="togglePasswordVisibility()"></i>
                    </span>
                  </div>
                  @if (loginFormControl['password'].invalid && loginFormControl['password'].touched) {
                    <div class="validation">
                      @if (loginFormControl['password'].errors?.['required']) {
                        <small>Enter password</small>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="my-2 d-flex justify-content-between align-items-center">
                <a href="forgot-password" class="auth-link text-black forgot">Forgot password?</a>
              </div>
              <div class="mt-4">
                <button class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" type="submit"
                        #loginButton>Log in
                </button>
                @if (loginError) {
                  <div class="validation mt-2 text-center fs-14">Incorrect email and password</div>
                }
                @if (unregisteredMail) {
                  <div class="validation mt-2 text-center fs-14">No account found with the email address</div>
                }
              </div>
            </form>
            <div class="text-center mt-4 font-weight-light login-question">
              Don't have an account? <a routerLink="/sign-up" class="text-primary line">Sign up</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


